import { match } from 'react-router-dom';
import ActivateEmailStore from '../../stores/ActivateEmailStore';

export enum ActivateEmailStatus {
  /** Email activation completed. */
  ACTIVATED,

  /** Email activation token is invalid or network error. */
  INVALID,

  /** Email activation request has not been sent. */
  NOT_STARTED,

  /** Email activation request has been sent and waiting server response. */
  WAITING
}

export interface ActivateEmailProps {
  /** URL query parameters. Use `.params` to access the param map. */
  match: match<{ uid: string, token: string }>,
  activateEmailStore?: ActivateEmailStore
}



// WEBPACK FOOTER //
// ./src/types/pages/ActivateEmail.ts